<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">OSTVARENI SATI</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>
      <div class="odabirDatuma" style="margin-right: 30px">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>
      <div *ngIf="linije" class="odabirDatuma">
        <label>Linija:</label>
        <dx-select-box
          [items]="linije"
          [value]="linije[0].idlinija"
          valueExpr="idlinija"
          displayExpr="li_naziv"
          [width]="250"
          (onValueChanged)="promjenaLinije($event)"
        >
        </dx-select-box>
      </div>
    </div>

    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="ostvareniSati"
        [wordWrapEnabled]="true"
        keyExpr="idppdjelatnikplan"
        [showBorders]="false"
        [columnAutoWidth]="true"
        [showColumnLines]="true"
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Ostvareni sati</h2>
            <p class="mt-0">Popis djelatnika i ostvarenih radnih sati</p>
          </div>
        </div>

        <!-- <dxo-header-filter [visible]="true"></dxo-header-filter> -->
        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>
        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>
        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>
        <dxo-grouping [autoExpandAll]="false"></dxo-grouping>

        <dxi-column
          dataField="dp_djelatnik"
          caption="Djelatnik"
          [groupIndex]="0"
        ></dxi-column>
        <dxi-column
          dataField="planproizvodnje_idplanproizvodnje"
          caption="Plan"
          [width]="100"
        ></dxi-column>
        <dxi-column
          dataField="pp_datumsmjena"
          dataType="date"
          caption="Datum"
          [width]="200"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="dp_vrijemeod"
          caption="Vrijeme od"
          [width]="105"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="dp_vrijemedo"
          caption="Vrijeme do"
          [width]="105"
          alignment="left"
        ></dxi-column>
        <dxi-column
          dataField="vrijemeradausatima"
          caption="Ostvareni sati"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vrijemerada"
          caption="Planirani sati"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="li_naziv"
          caption="Linija"
          [width]="250"
        ></dxi-column>
        <dxi-column
          dataField="dp_napomena"
          caption="Napomena"
          [minWidth]="250"
        ></dxi-column>

        <dxo-summary>
          <dxi-group-item
            column="vrijemeradausatima"
            summaryType="sum"
            [alignByColumn]="true"
            displayFormat="{0}"
          >
          </dxi-group-item>
          <dxi-group-item
            column="vrijemerada"
            summaryType="sum"
            [alignByColumn]="true"
            displayFormat="{0}"
          >
          </dxi-group-item>
          <dxi-total-item
            column="vrijemeradausatima"
            summaryType="sum"
            displayFormat="Ukupno: {0}"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
          >
          </dxi-total-item>
          <dxi-total-item
            column="vrijemerada"
            summaryType="sum"
            displayFormat="Ukupno: {0}"
            [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
          >
          </dxi-total-item>
        </dxo-summary>
        <dxi-sort-by-group-summary-info
          summaryItem="count"
        ></dxi-sort-by-group-summary-info>
      </dx-data-grid>
    </div>
  </div>
</div>
